<app-action-modal #actionModal [disabled]="submitted" (submitted)="confirm()">
  <ng-container mainTitle i18n>Supprimer cette résiliation ?</ng-container>
  <ng-container submitButtonLabel i18n>Supprimer</ng-container>
</app-action-modal>
